export default __webpack_public_path__ + "images/026912434d5cdeca9f17b97ccded69d8-county.jpg";